import Config from '../../config';
import TextContainer from '../../building_blocks/text_container';

import { Point, Size } from '../../helpers';

class StatementGeometry {

    constructor(position) {

        this._position = new Point(position.x, position.y);
        this._size = new Size(0, 0);

        this._textLineContainerHeight = 0;
        this._inputPosition = new Point(0, 0);
        this._outputPositions = [ new Point(0, 0) ];

        this._statementPosition = new Point(0, 0);
    }

    translate(dx, dy) {

        this._position.translate(dx, dy);
        this._inputPosition.translate(dx, dy);

        this._statementPosition.translate(dx, dy);
        this._outputPositions[0].translate(dx, dy);
    }

    updateGeometry(canvas, font, position, statement) {

        let currentPosition = new Point(position.x, position.y);

        this._position.copyFrom(currentPosition);
        this._inputPosition.copyFrom(currentPosition);

        this._textLineContainerHeight = TextContainer.getTextContainerHeight(font);

        currentPosition.y += Config.Style.ChatItem.Spacing.Vertical;

        this._statementPosition.copyFrom(currentPosition);

        currentPosition.y += this._textLineContainerHeight + Config.Style.ChatItem.Spacing.Vertical + Config.Style.Anchors.Size / 2;
        this._outputPositions[0].copyFrom(currentPosition);

        this._updateSize(canvas, font, statement);
    }

    _updateSize(canvas, font, statement) {
        
        this._size.width = 0;
        this._size.height = this._outputPositions[0].y - this._inputPosition.y;
            
        let currentTextContainerWidth = TextContainer.getTextContainerWidth(canvas, 
                                                                            font, 
                                                                            this._textLineContainerHeight, 
                                                                            statement);

        if(currentTextContainerWidth > this._size.width)
            this._size.width = currentTextContainerWidth;
    }

    getPosition() {

        return this._position;
    }

    getSize() {

        return this._size;
    }

    getInputPosition() {

        return this._inputPosition;
    }

    getOutputPositions() {

        return this._outputPositions;
    }

    getOutputPosition(index) {

        return this._outputPositions[index];
    }
    
    getOutputCount() {

        return this._outputPositions.length;
    }

    getStatementPosition() {

        return this._statementPosition;
    }
}

export default StatementGeometry;